/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

import HintBox from "../../components/Box/HintBox/HintBox";
import ProgressBar from "../../components/ProgressBar/ProgressBar";
import progressBarsteps from "./progressBarSteps";
import React from "react";
import {
  APPLICATION_STATUS_ALIMONY,
  APPLICATION_STATUS_BANK_ACCOUNT,
  APPLICATION_STATUS_CASH,
  APPLICATION_STATUS_CHECKED,
  APPLICATION_STATUS_CHECKING,
  APPLICATION_STATUS_INCOME_ALIMONY,
  APPLICATION_STATUS_INCOME_ASSETS,
  APPLICATION_STATUS_INCOME_CHILD_ALLOWANCE,
  APPLICATION_STATUS_INCOME_DESCRIPTIVE,
  APPLICATION_STATUS_INCOME_EMPLOYMENT,
  APPLICATION_STATUS_INCOME_LIVING,
  APPLICATION_STATUS_INCOME_OTHER,
  APPLICATION_STATUS_INCOME_PARENTAL_ALLOWANCE,
  APPLICATION_STATUS_INCOME_PENSION,
  APPLICATION_STATUS_INCOME_RENT,
  APPLICATION_STATUS_INCOME_SELFEMPLOYMENT,
  APPLICATION_STATUS_INCOME_SICKNESS,
  APPLICATION_STATUS_INCOME_UNEMPLOYED_ALLOWANCE_1,
  APPLICATION_STATUS_INCOME_UNEMPLOYED_ALLOWANCE_2,
  APPLICATION_STATUS_INSURANCES,
  APPLICATION_STATUS_INTRO,
  APPLICATION_STATUS_JOB,
  APPLICATION_STATUS_LEGAL_EXPENSES_INSURANCE,
  APPLICATION_STATUS_LIVING_TYPE,
  APPLICATION_STATUS_MAINTENANCE_CLAIM,
  APPLICATION_STATUS_MOBILITY,
  APPLICATION_STATUS_OTHER_ASSETS,
  APPLICATION_STATUS_OTHER_EXPENSES,
  APPLICATION_STATUS_PAYMENT_OBLIGATIONS,
  APPLICATION_STATUS_PENSION_INSURANCE,
  APPLICATION_STATUS_PERSONAL,
  APPLICATION_STATUS_REALESTATE,
  APPLICATION_STATUS_RECEIPTS,
  APPLICATION_STATUS_REPRESENTATIVE,
  APPLICATION_STATUS_SOCIAL_SECURITY,
  APPLICATION_STATUS_SOCIAL_WELFARE,
  APPLICATION_STATUS_SPECIAL_BURDENS,
  APPLICATION_STATUS_SUMMARY,
  APPLICATION_STATUS_TAX,
  APPLICATION_STATUS_VEHICLES,
} from "./applicationStatus";
import Intro from "../../components/Form/ProcessCostSupport/Intro";
import LegalExpensesInsurance from "../../components/Form/ProcessCostSupport/LegalExpensesInsurance";
import Petitioner from "../../components/Form/ProcessCostSupport/Petitioner";
import Job from "../../components/Form/ProcessCostSupport/Job";
import LegalRepresentative from "../../components/Form/ProcessCostSupport/LegalRepresentative";
import MaintenanceClaims from "../../components/Form/ProcessCostSupport/MaintenanceClaims";
import Alimony from "../../components/Form/ProcessCostSupport/Alimony";
import SocialWelfare from "../../components/Form/ProcessCostSupport/SocialWelfare";
import IncomeEmployment from "../../components/Form/ProcessCostSupport/IncomeEmployment";
import IncomeSelfEmployment from "../../components/Form/ProcessCostSupport/IncomeSelfEmployment";
import IncomeRent from "../../components/Form/ProcessCostSupport/IncomeRent";
import IncomeAssets from "../../components/Form/ProcessCostSupport/IncomeAssets";
import IncomeChildAllowance from "../../components/Form/ProcessCostSupport/IncomeChildAllowance";
import IncomeLiving from "../../components/Form/ProcessCostSupport/IncomeLiving";
import IncomeAlimony from "../../components/Form/ProcessCostSupport/IncomeAlimony";
import IncomePension from "../../components/Form/ProcessCostSupport/IncomePension";
import IncomeUnemploymentAllowance from "../../components/Form/ProcessCostSupport/IncomeUnemploymentAllowance";
import IncomeUnemploymentAllowance2 from "../../components/Form/ProcessCostSupport/IncomeUnemployementAllowance2";
import IncomeSickness from "../../components/Form/ProcessCostSupport/IncomeSickness";
import IncomeParentalAllowance from "../../components/Form/ProcessCostSupport/IncomeParentalAllowance";
import IncomeOther from "../../components/Form/ProcessCostSupport/IncomeOther";
import IncomeDescriptive from "../../components/Form/ProcessCostSupport/IncomeDescriptive";
import BankAccounts from "../../components/Form/ProcessCostSupport/BankAccounts";
import RealEstate from "../../components/Form/ProcessCostSupport/RealEstate";
import Vehicles from "../../components/Form/ProcessCostSupport/Vehicles";
import CashValuables from "../../components/Form/ProcessCostSupport/CashValuables";
import PensionInsurances from "../../components/Form/ProcessCostSupport/PensionInsurances";
import OtherAssets from "../../components/Form/ProcessCostSupport/OtherAssets";
import TaxDeduction from "../../components/Form/ProcessCostSupport/TaxDeduction";
import SocialSecurityDeduction from "../../components/Form/ProcessCostSupport/SocialSecurityDeduction";
import OtherInsuranceDeduction from "../../components/Form/ProcessCostSupport/OtherInsuranceDeduction";
import MobilityCostDeduction from "../../components/Form/ProcessCostSupport/MobilityCostDeduction";
import OtherExpensesDeduction from "../../components/Form/ProcessCostSupport/OtherExpensesDeduction";
import LivingType from "../../components/Form/ProcessCostSupport/LivingType";
import PaymentObligations from "../../components/Form/ProcessCostSupport/OtherPaymentObligations";
import SpecialBurdens from "../../components/Form/ProcessCostSupport/SpecialBurdens";
import ReceiptsUpload from "../../components/Form/ProcessCostSupport/Receipts/ReceiptsUpload";
import Summary from "../../components/Form/ProcessCostSupport/Summary";
import Button from "@mui/material/Button";
import { Link } from "react-router";
import CheckIcon from "../../assets/icons/common/toggleable/IconCheck";
import { getCaseLink } from "../productService";
import { FormSteps } from "../../types/FormServiceBase";
import SummaryHintBox from "../../components/Form/Common/SummaryHintBox";

const formSteps: FormSteps = {
  [APPLICATION_STATUS_INTRO]: {
    title: "Antrag - Assistent | Legalbird",
    stepUrl: "assistent",
    applicationStatus: APPLICATION_STATUS_INTRO,
    render: (props) => (
      <>
        <HintBox headline={"Ihr Verfahrenskostenhilfe-Assistent"}>
          <p>
            Damit das Gericht die Kosten für Sie übernimmt, müssen Sie Ihre finanzielle Situation genau beschreiben. Dafür muss ein Formular ausgefüllt und
            Belege eingereicht werden. Mit dem Assistenten müssen Sie nichts ausdrucken und können sicher sein, dass das Formular richtig ausgefüllt wird und
            vollständig ist.
          </p>
        </HintBox>
        <ProgressBar steps={progressBarsteps} active={"personal"} progress={10} />
        <Intro {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_LEGAL_EXPENSES_INSURANCE]: {
    title: "Antrag - Rechtsschutzversicherung | Legalbird",
    stepUrl: "rechtsschutzversicherung",
    applicationStatus: APPLICATION_STATUS_LEGAL_EXPENSES_INSURANCE,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"personal"} progress={14} />
        <LegalExpensesInsurance {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_PERSONAL]: {
    title: "Antrag - Persönliche Angaben | Legalbird",
    stepUrl: "persoenliche-angaben",
    applicationStatus: APPLICATION_STATUS_PERSONAL,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"personal"} progress={16} />
        <Petitioner {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_JOB]: {
    title: "Antrag - Aktueller Beruf | Legalbird",
    stepUrl: "aktueller-beruf",
    applicationStatus: APPLICATION_STATUS_JOB,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"personal"} progress={19} />
        <Job {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_REPRESENTATIVE]: {
    title: "Antrag - Gesetzlicher Vertreter | Legalbird",
    stepUrl: "gesetzlicher-vertreter",
    applicationStatus: APPLICATION_STATUS_REPRESENTATIVE,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"personal"} progress={22} />
        <LegalRepresentative {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_MAINTENANCE_CLAIM]: {
    title: "Antrag - Unterhaltsanspruch | Legalbird",
    stepUrl: "unterhaltsanspruch",
    applicationStatus: APPLICATION_STATUS_MAINTENANCE_CLAIM,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"personal"} progress={25} />
        <MaintenanceClaims {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_ALIMONY]: {
    title: "Antrag - Unterhaltszahlungen | Legalbird",
    stepUrl: "unterhaltszahlungen",
    applicationStatus: APPLICATION_STATUS_ALIMONY,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"personal"} progress={28} />
        <Alimony {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_SOCIAL_WELFARE]: {
    title: "Antrag - Sozialilfe | Legalbird",
    stepUrl: "sozialhilfe",
    applicationStatus: APPLICATION_STATUS_SOCIAL_WELFARE,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"personal"} progress={31} />
        <SocialWelfare {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_INCOME_EMPLOYMENT]: {
    title: "Antrag - Arbeitnehmer | Legalbird",
    stepUrl: "arbeitnehmer",
    applicationStatus: APPLICATION_STATUS_INCOME_EMPLOYMENT,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"income"} progress={36} />
        <IncomeEmployment {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_INCOME_SELFEMPLOYMENT]: {
    title: "Antrag - Selbstständige Arbeit | Legalbird",
    stepUrl: "selbststaendig",
    applicationStatus: APPLICATION_STATUS_INCOME_SELFEMPLOYMENT,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"income"} progress={37} />
        <IncomeSelfEmployment {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_INCOME_RENT]: {
    title: "Antrag - Vermietung | Legalbird",
    stepUrl: "vermietung",
    applicationStatus: APPLICATION_STATUS_INCOME_RENT,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"income"} progress={39} />
        <IncomeRent {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_INCOME_ASSETS]: {
    title: "Antrag - Kapitalvermögen | Legalbird",
    stepUrl: "kapitalvermoegen",
    applicationStatus: APPLICATION_STATUS_INCOME_ASSETS,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"income"} progress={40} />
        <IncomeAssets {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_INCOME_CHILD_ALLOWANCE]: {
    title: "Antrag - Kindergeld | Legalbird",
    stepUrl: "kindergeld",
    applicationStatus: APPLICATION_STATUS_INCOME_CHILD_ALLOWANCE,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"income"} progress={42} />
        <IncomeChildAllowance {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_INCOME_LIVING]: {
    title: "Antrag - Wohngeld | Legalbird",
    stepUrl: "wohngeld",
    applicationStatus: APPLICATION_STATUS_INCOME_LIVING,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"income"} progress={43} />
        <IncomeLiving {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_INCOME_ALIMONY]: {
    title: "Antrag - Unterhalt | Legalbird",
    stepUrl: "unterhalt",
    applicationStatus: APPLICATION_STATUS_INCOME_ALIMONY,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"income"} progress={45} />
        <IncomeAlimony {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_INCOME_PENSION]: {
    title: "Antrag - Rente | Legalbird",
    stepUrl: "rente",
    applicationStatus: APPLICATION_STATUS_INCOME_PENSION,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"income"} progress={46} />
        <IncomePension {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_INCOME_UNEMPLOYED_ALLOWANCE_1]: {
    title: "Antrag - Arbeitslosengeld I | Legalbird",
    stepUrl: "alg1",
    applicationStatus: APPLICATION_STATUS_INCOME_UNEMPLOYED_ALLOWANCE_1,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"income"} progress={48} />
        <IncomeUnemploymentAllowance {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_INCOME_UNEMPLOYED_ALLOWANCE_2]: {
    title: "Antrag - Arbeitslosengeld II | Legalbird",
    stepUrl: "alg2",
    applicationStatus: APPLICATION_STATUS_INCOME_UNEMPLOYED_ALLOWANCE_2,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"income"} progress={49} />
        <IncomeUnemploymentAllowance2 {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_INCOME_SICKNESS]: {
    title: "Antrag - Krankengeld | Legalbird",
    stepUrl: "krankengeld",
    applicationStatus: APPLICATION_STATUS_INCOME_SICKNESS,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"income"} progress={51} />
        <IncomeSickness {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_INCOME_PARENTAL_ALLOWANCE]: {
    title: "Antrag - Elterngeld | Legalbird",
    stepUrl: "elterngeld",
    applicationStatus: APPLICATION_STATUS_INCOME_PARENTAL_ALLOWANCE,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"income"} progress={54} />
        <IncomeParentalAllowance {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_INCOME_OTHER]: {
    title: "Antrag - Sonstige Einnahmen | Legalbird",
    stepUrl: "sonstige-einnahmen",
    applicationStatus: APPLICATION_STATUS_INCOME_OTHER,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"income"} progress={55} />
        <IncomeOther {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_INCOME_DESCRIPTIVE]: {
    title: "Antrag - Sonstiger Unterhalt | Legalbird",
    stepUrl: "sonstiger-unterhalt",
    applicationStatus: APPLICATION_STATUS_INCOME_DESCRIPTIVE,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"income"} progress={56} />
        <IncomeDescriptive {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_BANK_ACCOUNT]: {
    title: "Antrag - Konten | Legalbird",
    stepUrl: "konten",
    applicationStatus: APPLICATION_STATUS_BANK_ACCOUNT,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"assets"} progress={60} />
        <BankAccounts {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_REALESTATE]: {
    title: "Antrag - Grundeigentum | Legalbird",
    stepUrl: "grundeigentum",
    applicationStatus: APPLICATION_STATUS_REALESTATE,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"assets"} progress={64} />
        <RealEstate {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_VEHICLES]: {
    title: "Antrag - Kraftfahrzeuge | Legalbird",
    stepUrl: "kraftfahrzeuge",
    applicationStatus: APPLICATION_STATUS_VEHICLES,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"assets"} progress={68} />
        <Vehicles {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_CASH]: {
    title: "Antrag - Bargeld und Wertgegenstände | Legalbird",
    stepUrl: "bargeld-wertgegenstaende",
    applicationStatus: APPLICATION_STATUS_CASH,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"assets"} progress={72} />
        <CashValuables {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_PENSION_INSURANCE]: {
    title: "Antrag - Versicherungen | Legalbird",
    stepUrl: "lebensversicherungen",
    applicationStatus: APPLICATION_STATUS_PENSION_INSURANCE,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"assets"} progress={76} />
        <PensionInsurances {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_OTHER_ASSETS]: {
    title: "Antrag - Sonstiges Vermögen | Legalbird",
    stepUrl: "sontiges-vermoegen",
    applicationStatus: APPLICATION_STATUS_OTHER_ASSETS,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"assets"} progress={80} />
        <OtherAssets {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_TAX]: {
    title: "Antrag - Steuern | Legalbird",
    stepUrl: "steuern",
    applicationStatus: APPLICATION_STATUS_TAX,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"expenses"} progress={85} />
        <TaxDeduction {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_SOCIAL_SECURITY]: {
    title: "Antrag - Sozialversichungsbeiträge | Legalbird",
    stepUrl: "sozialversicherung",
    applicationStatus: APPLICATION_STATUS_SOCIAL_SECURITY,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"expenses"} progress={87} />
        <SocialSecurityDeduction {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_INSURANCES]: {
    title: "Antrag - Versicherungen | Legalbird",
    stepUrl: "versicherungen",
    applicationStatus: APPLICATION_STATUS_INSURANCES,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"expenses"} progress={88} />
        <OtherInsuranceDeduction {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_MOBILITY]: {
    title: "Antrag - Fahrtkosten | Legalbird",
    stepUrl: "fahrtkosten",
    applicationStatus: APPLICATION_STATUS_MOBILITY,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"expenses"} progress={90} />
        <MobilityCostDeduction {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_OTHER_EXPENSES]: {
    title: "Antrag - Werbungskosten | Legalbird",
    stepUrl: "werbungskosten",
    applicationStatus: APPLICATION_STATUS_OTHER_EXPENSES,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"expenses"} progress={91} />
        <OtherExpensesDeduction {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_LIVING_TYPE]: {
    title: "Antrag - Wohnkosten | Legalbird",
    stepUrl: "wohnkosten",
    applicationStatus: APPLICATION_STATUS_LIVING_TYPE,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"expenses"} progress={93} />
        <LivingType {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_PAYMENT_OBLIGATIONS]: {
    title: "Antrag - Sonstige Zahlungsverpflichtungen | Legalbird",
    stepUrl: "zahlungsverpflichtungen",
    applicationStatus: APPLICATION_STATUS_PAYMENT_OBLIGATIONS,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"expenses"} progress={94} />
        <PaymentObligations {...props} />
      </>
    ),
  },
  [APPLICATION_STATUS_SPECIAL_BURDENS]: {
    title: "Antrag - Besondere Belastungen | Legalbird",
    stepUrl: "besondere-belastungen",
    applicationStatus: APPLICATION_STATUS_SPECIAL_BURDENS,
    render: (props) => (
      <>
        <ProgressBar steps={progressBarsteps} active={"expenses"} progress={96} />
        <SpecialBurdens {...props} />
      </>
    ),
  },

  [APPLICATION_STATUS_SUMMARY]: {
    title: "Antrag - Zusammenfassung | Legalbird",
    stepUrl: "angaben-pruefen",
    applicationStatus: APPLICATION_STATUS_SUMMARY,
    render: (props) => (
      <>
        <SummaryHintBox />
        <Summary {...props} />
      </>
    ),
  },

  [APPLICATION_STATUS_RECEIPTS]: {
    title: "Antrag - Belege hochladen | Legalbird",
    stepUrl: "belege",
    applicationStatus: APPLICATION_STATUS_RECEIPTS,
    render: (props) => (
      <>
        <HintBox headline={"Belege hochladen"}>
          <p>
            Ihr Antrag auf Verfahrenskostenhilfe kann nur bewilligt werden, wenn zu Ihrer finanziellen Situation alle Belege vorliegen. Sie sehen hier, welche
            Unterlagen Sie in Ihrem Fall brauchen und können diese direkt hochladen.
          </p>
        </HintBox>
        <ReceiptsUpload {...props} />
      </>
    ),
  },

  [APPLICATION_STATUS_CHECKING]: {
    title: "Antrag - Wird geprüft | Legalbird",
    stepUrl: "wird-geprueft",
    applicationStatus: APPLICATION_STATUS_CHECKING,
    render: ({ product }) => (
      <>
        <HintBox headline={"Ihr Antrag wird geprüft..."}>
          <p>
            Ihr Antrag wird aktuell geprüft. Sie erhalten zeitnah Rückmeldung, ob der Antrag eingereicht werden kann, oder noch etwas angepasst werden muss.
          </p>
          <Button color={"primary"} component={Link} to={getCaseLink(product.divorce)}>
            Zurück zum Fall
          </Button>
        </HintBox>
      </>
    ),
  },

  [APPLICATION_STATUS_CHECKED]: {
    title: "Antrag - Erfolgreich | Legalbird",
    stepUrl: "vollstaendig",
    applicationStatus: APPLICATION_STATUS_CHECKED,
    render: ({ product }) => (
      <>
        <HintBox headline={"Ihr Antrag ist vollständig"}>
          <CheckIcon active />
          <p>
            Ihr Antrag auf Verfahrenskostenhilfe wurde geprüft und ist vollständig. Wir reichen den Antrag zusammen mit dem Scheidungsantrag bei Gericht für Sie
            ein.
          </p>
          <Button color={"primary"} component={Link} to={getCaseLink(product.divorce)}>
            Zur Übersicht
          </Button>
        </HintBox>
      </>
    ),
  },
};

export default formSteps;
